import { track } from "@utils/rudderstack";

const VERSION = "v0403";

export type Journey = "signup" | "direct-import";

export function trackOnb(
  journey: Journey,
  screen: string,
  action: string,
  props?: Record<string, unknown>,
) {
  track(`${VERSION}_${journey}_${screen}_${action}`, props ?? {});
}

export function trackDirectImport(
  screen: string,
  action: string,
  props?: Record<string, unknown>,
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track(`direct_import_${screen}_${action}` as any, props ?? {});
}
